import React from 'react';
import { useState, useEffect } from "react";
import { getText } from '../../i18n';

export function CharacterLimitIndicator({ maxChars, inputStr }) {

    const [characterLimitLabel, setCharacterLimitLabel] = useState("Character Limit 0/50");
    const [characterLimitStatus, setCharacterLimitStatus] = useState("rgba(47, 43, 67, 0.6)");

    const strLength = inputStr.length;

    useEffect(() => {
        if (strLength > maxChars) {
            setCharacterLimitStatus("rgba(239, 78, 69, 1)")
        } else {
            setCharacterLimitStatus("rgba(47, 43, 67, 0.6)")
        }
    }, [maxChars, inputStr])



    return (

        <div style={{ fontSize: "14px", fontWeight: "400", textAlign: "left", color: characterLimitStatus, marginLeft: "8px", marginTop: "8px" }}>
            {getText('msg_971d6ded4edf')} {strLength}/{maxChars}
        </div>

    );

}
